import { classNames } from "@/lib/utils";
import styles from "./BrandLoading.module.scss";
import { useAtomValue } from "jotai";
import { blackState, darkerBackgroundColorState, themeState } from "@/lib/store";
import { isUndefined } from "lodash";
import FaIcon from "@/components/fa-icon/FaIcon";

const BrandLoading = (props) => {
    const black = useAtomValue(blackState);
    const darkerBackgroundColor = useAtomValue(darkerBackgroundColorState);
    const theme = useAtomValue(themeState);

    return (
        <div
            className={classNames(styles[(props.pathname.includes("/s/") || props.pathname.includes("/id")) && "stock-page"], styles.BrandLoading)}
            style={{ backgroundColor: isUndefined(theme) ? "#FFF" : props.stock && theme === "dark" ? black : darkerBackgroundColor, height: props.height && props.height, opacity: props.opacity && props.opacity }}
        >
            <div className={styles.loader}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <span className={styles["icon-container"]}>
                    <FaIcon aria-hidden className="fak fa-ortex-logo" />
                </span>

                <span className={styles["icon-container"]}>
                    <FaIcon aria-hidden className="fak fa-ortex-logo" />
                </span>
            </div>
        </div>
    );
};

export default BrandLoading;
